"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Option = _interopRequireDefault(require("../Option"));

var _utils = require("../utils");

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Category = function Category(_ref) {
  var borderRadius = _ref.borderRadius,
      label = _ref.label,
      items = _ref.items,
      showCheckbox = _ref.showCheckbox,
      size = _ref.size;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_styles.StyledCategory, {
    size: size
  }, label), items.map(function (subItem) {
    var id = (0, _utils.getId)(subItem);
    return _react.default.createElement(_Option.default, _extends({}, subItem, {
      key: id,
      id: id,
      borderRadius: borderRadius,
      showCheckbox: showCheckbox,
      size: size
    }));
  }));
};

var _default = Category;
exports.default = _default;